import * as actions from "./propertyCost.actions";
import * as api from "./propertyCost.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY, } from "./propertyCost.constants";
import * as hooks from "./propertyCost.hooks";
import * as promises from "./propertyCost.promises";
import { PropertyCostReducer, } from "./propertyCost.reducer";
import { saga } from "./propertyCost.saga";
import * as selectors from "./propertyCost.selectors";
export * from "./propertyCost.types";
export var REDUCER_KEY_PROPERTY_COSTS = REDUCER_KEY;
export var propertyCostModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: PropertyCostReducer,
    saga: saga,
    selectors: selectors,
    utils: {},
};
